// @flow

import type { TranslatorProps } from '@gandi/translate';

const translations = {
  golive: (__: TranslatorProps['__']) => __('General availability'),
  golive_description: (__: TranslatorProps['__']) =>
    __('Anyone can register available domains.'),
  landrush: (__: TranslatorProps['__']) => __('Landrush'),
  landrush_description: (__: TranslatorProps['__']) =>
    __(
      'Anyone can register before the general availability, for an extra fee.',
    ),
  sunrise: (__: TranslatorProps['__']) => __('Sunrise'),
  sunrise_description: (__: TranslatorProps['__']) =>
    __(
      'Holder of a trademark registered with TMCH can register domains during this period.',
    ),
  eap: (__: TranslatorProps['__']) => __('Early Access Period'),
  'eap-n': (current: string) => (__: TranslatorProps['__']) =>
    __('Early Access Period - Day %(current)s', { current }),
  eap_description: (__: TranslatorProps['__']) =>
    __(
      'Anyone can register before the general availability, for an extra fee.',
    ),
  new_landrush: (__: TranslatorProps['__']) =>
    __('Limited Registration Period'),
  new_landrush_description: (__: TranslatorProps['__']) =>
    __(
      'Submit your registration request to the Registry for verification. The Registry will provide you with a token that you will need to submit to Gandi in order to finalize your request.',
    ),
  new_sunrise_description: (__: TranslatorProps['__']) =>
    __(
      'Holder of a trademark registered with TMCH can register domains during this period. Domain names are allocated under the first come first served basis.',
    ),
  gay_landrush_description: (__: TranslatorProps['__']) =>
    __(
      'Holders of a registered regional or international trademark can register domains during this period.',
    ),
};

export const getTranslation = (
  translate: TranslatorProps['__'],
  key_: string,
  tld?: ?string,
  ...args: any
): string => {
  const key = tld ? `${tld}_${key_}` : key_;

  // $FlowFixMe[invalid-computed-prop]
  if (translations[key] && typeof translations[key](translate) === 'string') {
    // $FlowFixMe[invalid-computed-prop]
    return translations[key](translate);
  }

  if (key_.match(/^eap\d{1}/)) {
    return key_.match(/description/)
      ? (
          translations[
            // $FlowFixMe[invalid-computed-prop]
            `${String(tld)}_eap_description`
          ] ||
          // eslint-disable-next-line dot-notation
          translations['eap_description']
        )(translate)
      : translations['eap-n'](key.replace(/\D+/, ''))(translate);
  }

  // $FlowFixMe[invalid-computed-prop]
  if (args.length && translations[key]) {
    // $FlowFixMe[invalid-computed-prop]
    return translations[key](...args)(translate);
  }

  if (key !== key_) {
    return getTranslation(translate, key_, null, ...args);
  }

  return key;
};

export default getTranslation;
